<div class="contract-list">  
    <h6 *ngIf="((contracts$ | async)! == undefined ) || (contracts$ | async)!.length === 0 "> 
        Aucun contrat 
      </h6>
    <div *ngIf="(contracts$ | async) !== null" >
    <div class="contract" *ngFor="let contract of (contracts$ | async)!.slice().reverse(); index as i">
        <div class="contract-details">
            <h6> ID : <b>{{contract.contractId}}</b>, Type : <b>{{contract.type}}</b> - Statut: <b>{{contract.status}}</b></h6>
            <h6> Owner : <b>{{contract.customerId}}</b></h6>
            <h6> Provider : <b>{{contract.providerId}}</b></h6> 

            <h6> Titre: <b>{{contract.title}} </b></h6> 
            <h6> Description: <b>{{contract.description}} </b></h6> 
            <h6> Créé par : <b>{{contract.createdBy}}</b></h6> 
            <h6> Date création: {{dateFormat(contract.created)}}, Dernière mise a jour: {{dateFormat(contract.lastUpdated)}}</h6> 
        </div>

        <div class="contract-buttons"> 

            <!-- <button *ngIf="(contract.status === ContractStatus.NEW || contract.status === ContractStatus.SCHEDULED)"
                class="simple-button"  mat-button (click)="rescheduleContract(contract);$event.stopPropagation()">
                Reprg <mat-icon>calendar_month</mat-icon>
            </button>  -->

            <button *ngIf="(contract.status === ContractStatus.DRAFT)"
                class="simple-button"  mat-button (click)="deleteContract(contract.contractId);$event.stopPropagation()">
                Supprimer <mat-icon>delete</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.DRAFT || contract.status === ContractStatus.REFUSED)"
                class="simple-button"  mat-button (click)="openContractDialog(contract.providerId, +contract.contractId);$event.stopPropagation()">
                Editer <mat-icon>edit</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.DRAFT || contract.status === ContractStatus.REFUSED)"
                class="simple-button"  mat-button (click)="proposeContract(contract.contractId);$event.stopPropagation()">
                Proposer <mat-icon>send</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.PROPOSED )"
                class="simple-button"  mat-button (click)="withdrawContract(contract.contractId, contract.getActiveNonCarModificationId());$event.stopPropagation()">
                Retirer <mat-icon>undo</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.PROPOSED )"
                class="simple-button"  mat-button (click)="answerContract(contract.contractId, contract.getActiveNonCarModificationId(), false);$event.stopPropagation()">
                Refuser <mat-icon>block</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.PROPOSED )"
                class="simple-button"  mat-button (click)="answerContract(contract.contractId, contract.getActiveNonCarModificationId(), true);$event.stopPropagation()">
                Accepter <mat-icon>done</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.ACCEPTED )"
                class="simple-button"  mat-button (click)="submitContractUpdate(contract.contractId, contract.getActiveNonCarModificationId(), true);$event.stopPropagation()">
                Demander MAJ <mat-icon>update</mat-icon>
            </button>

            <button *ngIf="(contract.status === ContractStatus.ACCEPTED )"
                class="simple-button"  mat-button (click)="openContractModificationDialog(contract.contractId);$event.stopPropagation()">
                Ajouter véhicule <mat-icon>add</mat-icon>
            </button>
            <!-- 
            <button *ngIf="(contract.status === ContractStatus.SCHEDULED)"
                class="simple-button"  mat-button (click)="updateContractStatus(contract.contractId, ContractStatus.COMPLETED);$event.stopPropagation()">
                Completer <mat-icon>accept</mat-icon>
            </button>

            <button *ngIf="(contract.status !== ContractStatus.CANCELLED)"
                class="simple-button"  mat-button (click)="updateContractStatus(contract.contractId, ContractStatus.CANCELLED);$event.stopPropagation()">
                Annuler <mat-icon>cancel</mat-icon>
            </button> -->
            
        </div> 
        
        <div class="contract-transactions">
            <div class="contract-modifications">
                <h5> Modifications ({{contract.modifications.length}})</h5> 
                <span *ngIf="contract.modifications === null  || contract.modifications.length == 0">  
                    Aucune modification
                </span> 

                <h6> <b> Actives </b> </h6> 
                <div class="contract-modification-active" *ngFor="let mod of contract.modifications.slice().filter(isModificationActive).reverse(); index as i">
                    <span *ngIf="mod === null">  
                    {{i}} - null
                    </span>
                    <span *ngIf="mod != null">  
                        <h6> {{mod.id}} - <b> {{mod.type}} </b>
                            <a *ngIf="mod.carId != null" [routerLink]="['/buy/details']" [queryParams]="{id: mod.carId}"> 
                                {{getCarDesc(mod.carId)}}
                            </a> 
                            <br /> 
                            Services: <b> {{mod.businessLines}} </b> 
                            Notes: {{mod.notes}}, Statut: <b>{{mod.status}}</b>
                        </h6> 
                        <div class="contract-buttons"> 
                            <button *ngIf="(mod.status === ContractModificationStatus.PROPOSED)"
                                class="simple-button"  mat-button (click)="answerContract(contract.contractId, mod.id, false);$event.stopPropagation()">
                                Refuser <mat-icon>block</mat-icon>
                            </button>
                            <button *ngIf="(mod.status === ContractModificationStatus.PROPOSED)"
                                class="simple-button"  mat-button (click)="answerContract(contract.contractId, mod.id, true);$event.stopPropagation()">
                                Accepter <mat-icon>done</mat-icon>
                            </button>
                        </div> 
                        
                        <div class = "h7"> Créé le {{dateFormat(mod.created)}} par <b>{{mod.createdBy}}</b>. 
                            Mis à jour le {{dateFormat(mod.lastUpdated)}} par {{mod.lastUpdatedBy}}
                        </div> 
                    </span>
                </div> 

                <h6> <b> Non Actives </b> 
                    <button class="simple-button"  mat-button (click)="showNonActiveModifs = !showNonActiveModifs;$event.stopPropagation()">
                        {{ showNonActiveModifs ? 'Cacher':'Voir'}} <mat-icon>{{ showNonActiveModifs ? 'remove':'add'}}</mat-icon>
                    </button>
                </h6> 
                <div *ngFor="let mod of contract.modifications.slice().filter(isModificationNotActive).reverse(); index as i">  
                    <div class="contract-modification" *ngIf="showNonActiveModifs">
                        <span *ngIf="mod === null">  
                            {{i}} - null
                            </span>
                            <span *ngIf="mod != null">  
                            
                                <h6> {{mod.id}} - <b> {{mod.type}} </b>
                                    <a *ngIf="mod.carId != null" [routerLink]="['/buy/details']" [queryParams]="{id: mod.carId}"> 
                                        {{getCarDesc(mod.carId)}}
                                    </a> 
                                    <br /> 
                                    Services: <b> {{mod.businessLines}} </b> 
                                    Notes: {{mod.notes}}, Statut: <b>{{mod.status}}</b>
                                </h6> 
                                <div class="contract-buttons"> 
                                    <button *ngIf="(mod.status === ContractModificationStatus.PROPOSED)"
                                        class="simple-button"  mat-button (click)="answerContract(contract.contractId, mod.id, false);$event.stopPropagation()">
                                        Refuser <mat-icon>block</mat-icon>
                                    </button>
                                    <button *ngIf="(mod.status === ContractModificationStatus.PROPOSED)"
                                        class="simple-button"  mat-button (click)="answerContract(contract.contractId, mod.id, true);$event.stopPropagation()">
                                        Accepter <mat-icon>done</mat-icon>
                                    </button>
                                </div> 
                                
                                <div class = "h7"> Créé le {{dateFormat(mod.created)}} par <b>{{mod.createdBy}}</b>. 
                                    Mis à jour le {{dateFormat(mod.lastUpdated)}} par {{mod.lastUpdatedBy}}
                                </div> 
                            </span>
                    </div>
                </div> 
            </div>

            <div class="contract-lines">
                <h5> Lignes ({{contract.lines!.length!}})</h5> 
                <span *ngIf="contract.lines === null  || contract.lines.length == 0">  
                    Aucune ligne
                </span> 

                <h6> <b> Actives </b> </h6> 
                <div class= "contract-line-active" *ngFor="let line of contract.lines.slice().filter(isLineActive).reverse(); index as i">
                    <span *ngIf="line === null">  
                        {{i}} - null
                    </span>
                    <span *ngIf="line != null">  
                        <h6> {{line.id}} - 
                            <a *ngIf="line.carId != null" [routerLink]="['/buy/details']" [queryParams]="{id: line.carId}"> 
                                {{getCarDesc(line.carId)}}
                            </a> 
                            <br /> 
                            Services: <b> {{line.businessLines}} </b>,
                            Notes: {{line.notes}}, Modif ref: {{line.lastModificationRef}}, Statut: <b>{{line.status}}</b>
                        </h6> 
                        <div class="contract-buttons"> 
                            <button *ngIf="(line.status === ContractLineStatus.ACTIVE)"
                                class="simple-button"  mat-button (click)="submitCarContractModif(contract.contractId, line.carId, ContractModificationType.CAR_SUSPEND);$event.stopPropagation()">
                                Dmd suspension <mat-icon>block</mat-icon>
                            </button>
                            <button *ngIf="(line.status === ContractLineStatus.ACTIVE)"
                                class="simple-button"  mat-button (click)="submitCarContractModif(contract.contractId, line.carId, ContractModificationType.CAR_CLOSE);$event.stopPropagation()">
                                Dmd cloture <mat-icon>done</mat-icon>
                            </button>
                        </div> 
                        <div class = "h7"> Créé le {{dateFormat(line.created)}} par <b>{{line.createdBy}}</b>. 
                            Mis à jour le {{dateFormat(line.lastUpdated)}} par {{line.lastUpdatedBy}}
                        </div> 
                    </span>
                </div> 

                <h6> <b> Non Actives </b> 
                     
                    <button class="simple-button"  mat-button (click)="showNonActiveLines = !showNonActiveLines;$event.stopPropagation()">
                        {{ showNonActiveLines ? 'Cacher':'Voir'}} <mat-icon>{{ showNonActiveLines ? 'remove':'add'}}</mat-icon>
                    </button>
                </h6> 
                <div *ngFor="let line of contract.lines.slice().filter(isLineNotActive).reverse(); index as i">
                    <div class= "contract-line" *ngIf="showNonActiveLines">
                        <span *ngIf="line === null">  
                            {{i}} - null
                        </span>
                        <span *ngIf="line != null">  
                            <h6> {{line.id}} - 
                                <a *ngIf="line.carId != null" [routerLink]="['/buy/details']" [queryParams]="{id: line.carId}"> 
                                    {{getCarDesc(line.carId)}}
                                </a> 
                                <br /> 
                                Services: <b> {{line.businessLines}} </b>, 
                                Notes: {{line.notes}}, Modif ref: {{line.lastModificationRef}}, Statut: <b>{{line.status}}</b>
                            </h6> 
                            <div class="contract-buttons"> 
                                <button *ngIf="(line.status === ContractLineStatus.ACTIVE)"
                                    class="simple-button"  mat-button (click)="submitCarContractModif(contract.contractId, line.carId, ContractModificationType.CAR_SUSPEND);$event.stopPropagation()">
                                    Dmd suspension <mat-icon>block</mat-icon>
                                </button>
                                <button *ngIf="(line.status === ContractLineStatus.ACTIVE)"
                                    class="simple-button"  mat-button (click)="submitCarContractModif(contract.contractId, line.carId, ContractModificationType.CAR_CLOSE);$event.stopPropagation()">
                                    Dmd cloture <mat-icon>done</mat-icon>
                                </button>
                            </div> 
                            <div class = "h7"> Créé le {{dateFormat(line.created)}} par <b>{{line.createdBy}}</b>. 
                                Mis à jour le {{dateFormat(line.lastUpdated)}} par {{line.lastUpdatedBy}}
                            </div> 
                        </span>
                    <div>
                </div> 
            </div>
        </div>
        
    </div> 
</div>
</div> 
